import ApiService from "@/core/services/api.service";
// action types
export const GET_USERS = "getUsers";
export const GET_USER = "getUser";
export const GET_CAJEROS = "getCajeros";
export const GET_EJECUTIVOS = "getEjecutivos";
export const CREATE_USER = "createUser";
export const UPDATE_USER = "updateUser";
export const DELETE_USER = "deleteUser";
export const DESACTIVAR_USER = "desactivarUser";
export const CHANGE_USER_PASSWORD = "changeUserPassword";
export const RESET_USER_PASSWORD = "resetUserPassword";

export const RECOVERY_USER_PASSWORD = "recoveryUserPassword";
export const UPDATE_USER_PASSWORD = "updateUserPassword";
export const GET_USER_RECOVERY = "getUserRecovery";

// mutation types
export const SET_USER_ADMIN = "setUserAdmin";
export const SET_CAJEROS = "setCajeros";
export const SET_USERS = "setUsers";
export const SET_BUSINESS_ACCOUNT = "setBusinessAccount";

export const SET_ERROR = "setError";
//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'
const state = {
  errors: [],
  business: [],
  documents: [],
  branchs: [],
  users: [],
  cajeros: [],
  userAdmin: { empresa: {} },
};

const actions = {
  [GET_USERS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Usuario/v1/usuarios` }, "")
        .then(({ data }) => {
          context.commit(SET_USERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_USER](context, token) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${token}` }, "")
        .then(({ data }) => {
          context.commit(SET_USER_ADMIN, data);
          //console.log(("retorna usuario" + JSON.stringify(data));
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_CAJEROS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Usuario/v1/usuarios/cajeros` }, "")
        .then(({ data }) => {
          context.commit(SET_CAJEROS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_USER_RECOVERY](context, token) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get(
        { action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${token}/obtenerRecuperacion` },
        ""
      )
        .then(({ data }) => {
          //console.log(("retorna " + data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },

  [RECOVERY_USER_PASSWORD](context, rut) {
    return new Promise((resolve, reject) => {
      ApiService.get({ action: `/facturacioncomisionapi/api/OAuth/v1/usuario/${rut}/recuperarClave` })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [UPDATE_USER_PASSWORD](context, token) {
    return new Promise((resolve, reject) => {
      ApiService.get({
        action: `/facturacioncomisionapi/api/OAuth/v1/usuario/${token}/confirmaRecuperarClave`
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [CHANGE_USER_PASSWORD](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        { action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${user.token}/cambiarClave` },
        user
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]); //response.data.errors);
          reject(response);
        });
    });
  },
  [RESET_USER_PASSWORD](context, token) {
    return new Promise((resolve, reject) => {
      ApiService.get({
        action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${token}/resetearClave`
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [CREATE_USER](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post({ action: `/facturacioncomisionapi/api/Usuario/v1/usuario/` }, user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [UPDATE_USER](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        { action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${user.tokenUsuario}` },
        user
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DESACTIVAR_USER](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        { action: `/facturacioncomisionapi/api/Usuario/v1/desactivarusuario/${user.tokenUsuario}` },
        user
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [DELETE_USER](context, token) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.delete({ action: `/facturacioncomisionapi/api/Usuario/v1/usuario/${token}` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [GET_EJECUTIVOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Usuario/v1/usuarios/ejecutivos` }, "")
        .then(({ data }) => {
          // context.commit(SET_USERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_USER_ADMIN](state, data) {
    state.error = {};
    state.userAdmin = data;
  },
  [SET_USERS](state, data) {
    state.error = {};
    state.users = data;
  },
  [SET_CAJEROS](state, data) {
    state.error = {};
    state.cajeros = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
